import {
  useEffect, useState, useContext,
} from 'react';
import axios from 'axios';
import moment from 'moment';
import { DispatchMessageContext } from '../providers/MessageProvider';
import handleRequest from '../utils/handle-request';

async function doRequest(method, uri, form, cancelToken, contentType = 'application/json') {
  let formData;
  if (contentType === 'multipart/form-data') {
    formData = new FormData();
    Object.keys(form).forEach((property) => {
      // Formateo de fecha
      if (moment.isMoment(form[property])) {
        const date = form[property].format('YYYY-MM-DD');
        formData.set(property, date);
      } else {
        formData.set(property, form[property]);
      }
    });
  } else {
    formData = form;
  }
  const config = { cancelToken };
  return handleRequest(method, uri, formData, config);
}

function useFetch({
  initialUri = '',
  initialForm = {},
  contentType = 'application/json',
  initalMethod = 'get',
  showSuccessMessage = true,
  showErrorMessage = true,
}) {
  const dispatch = useContext(DispatchMessageContext);
  const [uri, setUri] = useState(initialUri);
  const [form, setForm] = useState(initialForm);
  const [method, setMethod] = useState(initalMethod);
  const [isLoading, setIsLoading] = useState(false);
  const { CancelToken } = axios;
  const { token, cancel } = CancelToken.source();

  useEffect(() => {
    dispatch({ type: 'reset' });
    return () => cancel('component unmount');
  }, [uri, form]);

  const fetch = async (data = null, config = {}) => {
    dispatch({ type: 'reset' });
    setIsLoading(true);
    const response = await doRequest(
      config.method || method,
      config.uri || uri,
      data || form,
      token,
      config.contentType || contentType,
    );
    setIsLoading(false);
    if (response.success) {
      if (showSuccessMessage) {
        dispatch({ type: 'success', message: response.message });
      }
      return response;
    }
    if (showErrorMessage) {
      dispatch({ type: 'error', message: response.message });
    }
    return response;
  };

  return {
    uri, setUri, form, setForm, fetch, isLoading, setMethod,
  };
}

export default useFetch;
